import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3bcb09a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widthRole meetingReg" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参展和赞助", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maincc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ttl" }, "2023 中国智能车大会暨国家智能车发展论坛"),
  /*#__PURE__*/_createElementVNode("div", { class: "ttl" }, "赞助及展览火热招募中"),
  /*#__PURE__*/_createElementVNode("div", { class: "tab2P" }, " 中 国 智 能 车 大 会 暨 国 家 智 能 车 发 展 论 坛 (National Intelligent Vehicle Development Forum)是国家自然科学基金委员会信息科学部和中 国自动化学会于 2015 年创办的品牌学术活动，旨在推动我国人工智能基础 研究领域重要里程碑计划——国家自然科学基金委员会重大研究计划“视 听觉信息的认知计算”，有力促进了我国智能车基础理论研究、成果原始创 新和高技术开发，增强我国智能车自主研发技术水平和实际应用能力，促进 智能车技术产业化应用，推动其在能源、交通等领域的深入应用和产业转型 升级。目前已成功举办 6 届，已成为全国从事智能车辆与自动驾驶相关领域 研发、生产及应用机构的科研和工程技术人员进行学术交流与技术研讨的 重要平台。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "tab2P" }, " 2023 中国智能车大会暨国家智能车发展论坛将为促进智能车基础理论 研究、成果原始创新和高技术开发提供开放互融的交流平台，增强我国智能 车自主研发技术水平和实际应用能力，促进智能车技术产业化应用，推动其 在能源、交通等领域的深入应用和产业转型升级。大会组委会诚邀相关单位 成为本次大会的赞助单位和展览单位，在大会期间向参会代表宣传企业文 化、展示企业成果。如有意向，请填写附件基本信息表，具体赞助及展览详 情烦请与组委会联系，感谢贵单位的大力支持与合作！ "),
  /*#__PURE__*/_createElementVNode("div", { class: "contactC" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "litTll1" }, "组委会联系方式："),
    /*#__PURE__*/_createElementVNode("p", null, "联系人：屈老师"),
    /*#__PURE__*/_createElementVNode("p", null, "电话：010-82544541 13311560430"),
    /*#__PURE__*/_createElementVNode("p", null, "邮箱：cac@caa.org.cn")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "foot1" }, [
    /*#__PURE__*/_createElementVNode("p", null, "中国自动化学会"),
    /*#__PURE__*/_createElementVNode("p", null, "2023 年 2 月 27 日")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "marT50" }, " 附件：赞助与展览细则 "),
  /*#__PURE__*/_createElementVNode("div", { class: "ttl2" }, [
    /*#__PURE__*/_createElementVNode("p", null, "2023 中国智能车大会暨国家智能车发展论坛"),
    /*#__PURE__*/_createElementVNode("p", null, "赞助与展览细则")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "litTll1" }, "一、条件要求"),
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createTextVNode(" 1、赞助及展览单位应有良好的社会声誉，企业、高校、研究院所均可。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 2、如企业赞助，其产品（或服务）应是所在行业知名品牌或新兴品牌。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 3、赞助单位及其产品（或服务）应与智能车及相关产业链关联。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "litTll1" }, "二、赞助方案类别及权益"),
  /*#__PURE__*/_createElementVNode("div", { class: "xize2" }, [
    /*#__PURE__*/_createElementVNode("div", null, "（一）钻石赞助方案 (50 万)"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode(" 1. 赠送本届论坛入场券 25 张(含前排座位、餐券)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛主要位置展位 1 个；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商名称在程序册、签到板等宣传物料中呈现；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4. 两场分论坛易拉宝宣传((易拉宝由企业自行提供)； "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 5. 《论坛程序册》赞助单位整版彩色广告；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 6. 企业宣传单页放入大会资料袋，宣传材料自备；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 7. 主论坛开场前播放单位宣传视频（不超过 3 分钟）；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 8. 晚宴前播放单位宣传视频（不超过 3 分钟）。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "xize2" }, [
    /*#__PURE__*/_createElementVNode("div", null, "（二）铂金赞助方案 (30 万)"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode(" 1. 赠送本届论坛入场券 15 张(含前排座位、餐券) ；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛主要位置展位 1 个；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商名称在程序册、签到板等宣传物料中呈现；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4. 一场分论坛易拉宝宣传((易拉宝由企业自行提供)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 5. 企业宣传单页放入大会资料袋，宣传材料自备；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 6. 在大会其中一个专题论坛开场前播放单位宣传片（片长不超过 3 分钟）；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 7. 晚宴前播放单位宣传视频（不超过 3 分钟）。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "xize2" }, [
    /*#__PURE__*/_createElementVNode("div", null, "（三）金牌赞助方案 (20 万)"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode(" 1. 赠送本届论坛入场券 10 张(含前排座位、餐券)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛主要位置展位 1 个；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商名称在程序册、签到板等宣传物料中呈现；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4. 企业宣传单页放入大会资料袋，宣传材料自备。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "xize2" }, [
    /*#__PURE__*/_createElementVNode("div", null, "（四）银牌赞助方案 (10 万)"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode(" 1. 赠送本届论坛入场券 3 张(含前排座位、餐券)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛主要位置展位 1 个；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商名称在程序册、签到板等宣传物料中呈现。 ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "xize2" }, [
    /*#__PURE__*/_createElementVNode("div", null, "（五）单项赞助"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "ttl3" }, "手提袋赞助（3 万元）"),
      /*#__PURE__*/_createTextVNode(" 1. 赞助商提供论坛专用手提袋 700 个；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛入场券 2 张(含前排座位、餐券)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商单位名称、LOGO 可在手提袋上呈现（内容需经过主办方审核）；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4. 赞助商名称在程序册、签到板、舞台背景板等宣传物料中呈现； ")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "ttl3" }, "笔记本赞助 （3 万元）"),
      /*#__PURE__*/_createTextVNode(" 1. 赞助商提供论坛专用笔记本 700 本；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛入场券 2 张(含前排座位、餐券)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商单位名称、LOGO 可在笔记本封底呈现（内容需经过主办方审核）；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4. 赞助商名称在程序册、签到板、舞台背景板等宣传物料中呈现； ")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "ttl3" }, "签字笔赞助 （3 万元）"),
      /*#__PURE__*/_createTextVNode(" 1. 赞助商提供论坛专用笔 700 支；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 2. 赠送本届论坛入场券 2 张(含前排座位、餐券)；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 3. 赞助商单位名称、LOGO 可在笔身上呈现（内容需经过主办方审核）；"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 4. 赞助商名称在程序册、签到板、舞台背景板等宣传物料中呈现； ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "litTll1" }, "三、展览信息"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" 本次展览包括标准展位、特装展位两种形式。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "boldS" }, "标准展位："),
    /*#__PURE__*/_createTextVNode("由组委会统一搭建标准展位，参展单位可展示展品或服务。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "boldS" }, "现场特展："),
    /*#__PURE__*/_createTextVNode("组委会提供光地展位，参展商需自行搭建。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"40px"} }, [
    /*#__PURE__*/_createElementVNode("span", { class: "boldS" }, "展位费用："),
    /*#__PURE__*/_createElementVNode("table", {
      border: "1",
      cellspacing: "0"
    }, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "展位形式"),
        /*#__PURE__*/_createElementVNode("td", null, "团体会员单位"),
        /*#__PURE__*/_createElementVNode("td", null, "非团体会员单位")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "标准展位（3m*3m*2.5m）"),
        /*#__PURE__*/_createElementVNode("td", null, "15000 元/个"),
        /*#__PURE__*/_createElementVNode("td", null, "30000 元/个")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "特装展位（18 ㎡起）"),
        /*#__PURE__*/_createElementVNode("td", null, "9800 元/9 ㎡"),
        /*#__PURE__*/_createElementVNode("td", null, "19800 元/9 ㎡")
      ])
    ])
  ])
], -1))

import leftMenu from '@/components/LeftMenu.vue';
import shortNav from '@/components/shortNav.vue'; 


export default /*#__PURE__*/_defineComponent({
  __name: 'support',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(leftMenu),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(shortNav, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ])
  ]))
}
}

})